 
var folder = "";

var htmlFolder = "https://file.thermaltake.com/pub/media/wysiwyg/key3/html";

if (window.location.hostname == "tw.thermaltake.com") {

    folder = "tw/";

    htmlFolder = "https://file.thermaltake.com/pub/media/wysiwyg/key3/html_tw";

}

/* ------  X1 -------------- */
function x1Voice() {
    if (window.location.hostname == "www.thermaltake.com.cn") {
        window.open('https://www.thermaltake.com/pub/media/wysiwyg/key3/db/support/usermanual/_c2015bbbea574983ae0166cb13b8b990.pdf');
    }
    else {
        window.open('https://bit.ly/2GijRo2');
    }
}

function x1app() {
    window.open('https://itunes.apple.com/us/app/x1-rgb/id1330134109?mt=8');
}


function x1appandroid() {

    if (window.location.hostname == "www.thermaltake.com.cn") {
        window.open('https://play.google.com/store/apps/details?id=com.t788.firstheadandroi');
    } else {
        window.open('https://bit.ly/x1appandroid');
    }
}

function x1software() {
    if (window.location.hostname == "www.thermaltake.com.cn") {
        window.open('https://www.thermaltake.com/pub/media/wysiwyg/key3/db/support/usermanual/X1_RGB_setup_V1.10.0.zip');
    }
    else {
        window.open('https://bit.ly/TteX1RGBSetupV1100');
    }
}

function ttNeonMaker() {
    if (window.location.hostname == "www.thermaltake.com.cn") {
        window.open('https://file.thermaltake.com/file/software/NeonMakerLightEditingSoftware_Setup_v118.zip');
    } else {
        window.open('https://bit.ly/TTNeonMakerLightEditingV118');
    }
}


function ttNeonMakerEventinfo() {
    if (window.location.hostname == "www.thermaltake.com.cn") {
        window.open('https://rammod.thermaltake.com/2022s1/');
    } else {
        window.open('https://rammod.thermaltake.com/2022s1/');
    }
}

function ttNeonMakerWeb() {
    if (window.location.hostname == "www.thermaltake.com.cn") {
        window.open('https://www.thermaltake.com/neonmaker');
    } else {
        window.open('https://www.thermaltake.com/neonmaker');
    }
}

function ttNeonMakerWebsite() {
    if (window.location.hostname == "www.thermaltake.com.cn") {
        window.open('https://www.thermaltake.com/neonmaker');
    } else {
        window.open('https://www.thermaltake.com/neonmaker');
    }
}



function ttNeonMakerDownloadProfiles() {
    if (window.location.hostname == "www.thermaltake.com.cn") {
        window.open('https://lightmix.thermaltake.com/Download.html');
    } else {
        window.open('https://lightmix.thermaltake.com/Download.html');
    }
}


function x1dM() {

    if (window.location.hostname == "www.thermaltake.com.cn") {
        window.open('https://www.thermaltake.com/pub/media/wysiwyg/key3/db/support/usermanual/_83a6c3d83f4344b1a7e8b91ccddcd30b.pdf');
    }

    else {
        window.open('https://bit.ly/2Ghkjab');
    }
}


function rcaio() {
    if (window.location.hostname == "www.thermaltake.com.cn") {
         window.open('/floe-rc240-cpu-memory-aio-liquid-cooler.html ', "_self");
    } else {
        window.open('/floe-rc240-cpu-memory-aio-liquid-cooler.html ', "_self");
    }
}



function x1UserGuide() {



    if (window.location.hostname == "www.thermaltake.com.cn") {

        window.open('https://www.thermaltake.com/pub/media/wysiwyg/key3/db/support/usermanual/_9ba0327590e84c9fb663cfb034ea0c00.pdf');

    } else if (window.location.hostname == "tw.thermaltake.com" || window.location.hostname == "mgttptw.thermaltake.com") {

        window.open('https://bit.ly/Key3x1UserGuide')

    } else if (window.location.hostname == "www.thermaltake.com.cn") {

        window.open('https://www.thermaltake.com/pub/media/wysiwyg/key3/db/support/usermanual/_9ba0327590e84c9fb663cfb034ea0c00.pdf');

    } else {

        window.open('https://bit.ly/Key3x1UserGuideEn');

    }

}


function IllumiPackAndroid() {
    window.open('https://play.google.com/store/apps/details?id=com.thermaltake.illumipack&pcampaignid=web_share');
}

function IllumiPackIOS() {
    window.open('https://apps.apple.com/tw/app/illumipack/id6654894610');
}



function newDPSGAppIOS() {

    window.open('https://itunes.apple.com/tw/app/tt-dps-g/id1028230950?l=zh&amp;mt=8');

}



function newDPSGAppAndroid() {

    window.open('https://play.google.com/store/apps/details?id=com.thermaltake.TtDPSG');

}



//Riing Plus RGB Software
function RiingPlusRGB() {
	if (window.location.hostname == "www.thermaltake.com.cn") {
        window.open('https://file.thermaltake.com/file/software/TTRGBPlus_Setup_310_x64.zip');
	} else {
	    window.open('https://bit.ly/TTRGBPlusV310');
	}
}



//Riing Plus RGB Software
function RiingPlusRGBVega() {
	if (window.location.hostname == "www.thermaltake.com.cn") {
        window.open('https://file.thermaltake.com/file/software/TTRGBPLUS_Setup_214_x64.zip');
	} else {
	    window.open('https://bit.ly/TTRGBPlusV214');
	}
}

//Riing Plus RGB Software 2.3
function RiingPlusRGB2() {
	if (window.location.hostname == "www.thermaltake.com.cn") {
        window.open('https://file.thermaltake.com/file/software/TTRGBPLUS_Setup_303_x64.zip');
	} else {
	    window.open('https://bit.ly/TTRGBPlusV303');
	}
}

//Riing Plus RGB Software V3
function TTRGBPlus3() {
	if (window.location.hostname == "www.thermaltake.com.cn") {
        window.open('https://file.thermaltake.com/file/software/TTRGBPLUS_Setup_310_x64.zip');
	} else {
	    window.open('https://bit.ly/TTRGBPlusV310');
	}
}

function TTRGBPlus3Manual() {
    window.open('https://file.thermaltake.com/file/qig/TTRGBPLUSV3_User_Manual.PDF');
}

//Riing Plus RGB Software 2.3
function RiingPlusRGBVega2() {
	if (window.location.hostname == "www.thermaltake.com.cn") {
        window.open('https://file.thermaltake.com/file/software/TTRGBPLUS_Setup_310_x64.zip');
	} else {
	    window.open('https://bit.ly/TTRGBPlusV215');
	}
}
//TTRGB Plus RGB Software 2.0Manual
function TTRGBPlus2Manual() {
    window.open('https://file.thermaltake.com/file/qig/TTRGBPLUS2.0_User_Manual.pdf');
}

function coolantp1000() {
    window.open('https://file.thermaltake.com/file/qig/CL-W246SeriesMSDS-ENforAmazon.pdf');
}

function coolantpT000() {
    window.open('https://file.thermaltake.com/file/qig/CL-W245SeriesMSDS-ENforAmazon.pdf');
}



//Riing Plus RGB Software

function TTRGBPLUS() {
    if(window.location.hostname == "innertw.thermaltake.com" || window.location.hostname == "innertw.thermaltake.com"  || window.location.hostname == "tw.thermaltake.com"){
        window.open('https://ttrgbplus.thermaltake.com/tw/');
    }else{
        window.open('https://TTrgbplus.thermaltake.com');
    }
}

function TTTOUGHRAMRGBsoftware() {
     if (window.location.hostname == "www.thermaltake.com.cn") {

         window.open('https://file.thermaltake.com/file/software/TOUGHRAM_Setup_109_x64_20220421.zip');
                    
     } else {
         window.open('https://bit.ly/TOUGHRAMSoftwareV109new');
     }
}


function TTiTAKE() {
	if (window.location.hostname == "www.thermaltake.com.cn") {

        window.open('https://file.thermaltake.com/file/software/TTiTakeEngineSetup_V159.zip');
	} else {
		window.open('https://bit.ly/TTiTakeSetupV159');
	}
}

function TTiTAKE64() {
	if (window.location.hostname == "www.thermaltake.com.cn") {

        window.open('https://file.thermaltake.com/file/software/TTiTakeEngineSetup_x64_V135.zip');
	} else {
		window.open('https://bit.ly/TTiTakeSetup64bitV135');
	}
}

function TTiTAKERazerSyncGuide() {
	if (window.location.hostname == "www.thermaltake.com.cn") {

        window.open('https://file.thermaltake.com/file/qig/iTakexRazerChromaSettingsSOP.pdf');
	} else if (window.location.hostname == "tw.thermaltake.com" || window.location.hostname == "innertw.thermaltake.com" || window.location.hostname == "mgttptw.thermaltake.com") {
		window.open('https://bit.ly/iTakexRazerChromaSettingsSOPtw');
	} else {
		window.open('https://bit.ly/iTakexRazerChromaSettingsSOP');
	}
}


function TTiTAKEpage() {
	window.open('https://www.thermaltake.com/software_itake');
}

function TTiTAKERAppStore() {
	window.open('https://itunes.apple.com/us/app/tt-itake/id1448449968?l=zh&ls=1&mt=8');
}

function TTiTAKEGooglePlay() {

	if (window.location.hostname == "www.thermaltake.com.cn") {
		window.open('https://shouji.baidu.com/software/25559420.html');
	} else {
		window.open('https://play.google.com/store/apps/details?id=com.thermaltake.t829.itake');
	}
}


//Riing 語音

function VoiceInputCommand() {

    if (window.location.hostname == "www.thermaltake.com.cn") {
        window.open('https://www.thermaltake.com/pub/media/wysiwyg/key3/db/support/usermanual/_f2e5b60f80744023915fd5267d86bd6b.pdf');
    }
    else {
        window.open('https://bit.ly/VoiceInputCommand');
    }
}


//TT_XR_Racing_Control.zip 賽車XR軟體

function TT_XR_Racing_Control() {

    if (window.location.hostname == "www.thermaltake.com.cn") {
        window.open('https://file.thermaltake.com/file/software/TT_XR_Racing_Control.zip');
    }
    else {
        window.open('https://file.thermaltake.com/file/software/TT_XR_Racing_Control.zip');
    }
}





//PSU 語音

function psuVoiceInputCommand() {

    if (window.location.hostname == "www.thermaltake.com.cn") {
        window.open('https://www.thermaltake.com/pub/media/wysiwyg/key3/db/support/usermanual/_6a4a292c201e4ba5be4171342da7a0c0.pdf');
    }
    else {
        window.open('https://bit.ly/2GXy9vH');
    }

}



//溫度表

function temperatureColorScale() {



    if (window.location.hostname == "www.thermaltake.com.cn") {

        window.open('https://www.thermaltake.com/pub/media/wysiwyg/key3/db/support/software/TemperatureColorScale.pdf');

    }

    else {

        window.open('https://bit.ly/2J4y6OW');

    }

}


function MotherboardSupportList() {
    if (window.location.hostname == "www.thermaltake.com.cn") {
        window.open('https://file.thermaltake.com/file/qig/MotherboardSupportList.pdf');
    }
    else {
        window.open('https://bit.ly/mbsupportlistram');
    }
}

function MotherboardSupportList4400() {
           if (window.location.hostname == "www.thermaltake.com.cn") {
               window.open('https://file.thermaltake.com/file/qig/TOUGHRAM_RGB_4000_4400MHz_8GB_QVL.pdf');
           } else {
               window.open('https://file.thermaltake.com/file/qig/TOUGHRAM_RGB_4000_4400MHz_8GB_QVL.pdf');
           }
}

function MotherboardSupportList4600() {
    if (window.location.hostname == "www.thermaltake.com.cn") {
        window.open('https://file.thermaltake.com/file/qig/TOUGHRAM_RGB_4600MHz_8GB_QVL.pdf');
    } else {
        window.open('https://file.thermaltake.com/file/qig/TOUGHRAM_RGB_4600MHz_8GB_QVL.pdf');
    }
}

function MotherboardSupportList4400norgb() {
    if (window.location.hostname == "www.thermaltake.com.cn") {
        window.open('https://file.thermaltake.com/file/qig/TOUGHRAM_8GB_4000_4400MHz_QVL.pdf');
    } else {
        window.open('https://file.thermaltake.com/file/qig/TOUGHRAM_8GB_4000_4400MHz_QVL.pdf');
    }
}

function MotherboardSupportList4000norgb() {

    if (window.location.hostname == "www.thermaltake.com.cn") {
        window.open('https://file.thermaltake.com/file/qig/TOUGHRAM_8GB_4000_4400MHz_QVL.pdf');
    } else {
        window.open('https://file.thermaltake.com/file/qig/TOUGHRAM_8GB_4000_4400MHz_QVL.pdf');
    }
}

function MotherboardSupportList4266norgb() {

    if (window.location.hostname == "www.thermaltake.com.cn") {
        window.open('#');
    } else {
        window.open('#');
    }
}


function MotherboardSupportList4400_20191230() {

    if (window.location.hostname == "www.thermaltake.com.cn") {
        window.open('https://file.thermaltake.com/file/qig/MotherboardSupportList4400MHz.pdf');
    } else {
        window.open('https://bit.ly/ram4400mbsupportlist');
    }
}

function MotherboardSupportList4000() {

    if (window.location.hostname == "www.thermaltake.com.cn") {
        window.open('https://file.thermaltake.com/file/qig/TOUGHRAM_RGB_4000_4400MHz_8GB_QVL.pdf');
    } else {
        window.open('https://file.thermaltake.com/file/qig/TOUGHRAM_RGB_4000_4400MHz_8GB_QVL.pdf');
    }

}

function MotherboardSupportList3236() {

    if (window.location.hostname == "www.thermaltake.com.cn") {
        window.open('https://file.thermaltake.com/file/qig/TOUGHRAM_RGB_16GB_32GB_QVL.pdf');
    } else {
        window.open('https://file.thermaltake.com/file/qig/TOUGHRAM_RGB_16GB_32GB_QVL.pdf');
    }
}



function MotherboardSupportList4000_20191230() {

    if (window.location.hostname == "www.thermaltake.com.cn") {
        window.open('https://file.thermaltake.com/file/qig/MotherboardSupportList4000MHz.pdf');
    } else {
        window.open('https://bit.ly/ram4000mbsupportlist');
    }

}

function MotherboardSupportList4266() {

    if (window.location.hostname == "www.thermaltake.com.cn") {
        window.open('https://file.thermaltake.com/file/qig/MotherboardSupportList4266MHz.pdf');
    } else {
        window.open('https://bit.ly/ram4266mbsupportlist');
    }

}

function MotherboardSupportList4266_20191230() {

    if (window.location.hostname == "www.thermaltake.com.cn") {
        window.open('https://file.thermaltake.com/file/qig/MotherboardSupportList4266MHz.pdf');
    } else {
        window.open('https://bit.ly/ram4266mbsupportlist');
    }

}
function MotherboardSupportListXG4000() {

    if (window.location.hostname == "www.thermaltake.com.cn") {
        window.open('https://file.thermaltake.com/file/qig/TOUGHRAM_XG_RGB_4000-4400_MHz_QVL_V1.pdf');
    } else {
        window.open('https://file.thermaltake.com/file/qig/TOUGHRAM_XG_RGB_4000-4400_MHz_QVL_V1.pdf');
    }

}
function MotherboardSupportListXG4600() {

    if (window.location.hostname == "www.thermaltake.com.cn") {
        window.open('https://file.thermaltake.com/file/qig/TOUGHRAM_XG_RGB_4600_MHz_QVL_V1.pdf');
    } else {
        window.open('https://file.thermaltake.com/file/qig/TOUGHRAM_XG_RGB_4600_MHz_QVL_V1.pdf');
    }

}



function rgbRAppStore() {
    window.open('https://itunes.apple.com/app/riing-plus-rgb/id1196653067?mt=8&ign-mpt=uo%3D4');
}

function rgbRGooglePlay() {
    window.open('https://play.google.com/store/apps/details?id=riing.riingrgbplus');
}

function ARTTRAppStore() {
    window.open('https://bit.ly/key3arttios');
    //https://apps.apple.com/app/id1492399044?fbclid=IwAR0o7RIs8aEuLUwd4RW_pY5swhGia3Ddx1_voPeZ_Z8vVtfD_5JJfS6N4go
}

function ARTTGooglePlay() {


     if (window.location.hostname == "www.thermaltake.com.cn") {

         window.open('https://mobile.baidu.com/item?docid=26775120&f0=search_searchContent%400_appBaseNormal%400');
     } else {
          window.open('https://bit.ly/key3arttiosgplay');
          //https://play.google.com/store/apps/details?id=com.thermaltake.ARTT
     }



   
    
}

//TTRacingControl
function TTRacingControl() {
     if (window.location.hostname == "www.thermaltake.com.cn") {

         window.open('https://file.thermaltake.com/file/qig/Thermaltake_Racing_Control.zip');
                    
     } else {
          window.open('https://file.thermaltake.com/file/qig/Thermaltake_Racing_Control.zip');
     }
}

//TT LCD Screen
function TTLCDScreenSoftware() {
     if (window.location.hostname == "www.thermaltake.com.cn") {

         window.open('https://file.thermaltake.com/file/software/TT_LCD_Screen_v140.zip');
                    
     } else {
         window.open('https://bit.ly/TTLCDScreenV140');
     }
}

function TTLCDScreenSoftwareManual() {
   
         window.open('https://file.thermaltake.com/file/qig/MINECUBE_360_Ultra_Software_manual_251021.pdf');
   
}


function ttcsWarranty() {
    window.open('https://my.thermaltake.com/csWarranty.aspx#tab-8');
}
function ttcsWarranty_tw() {
    window.open('https://my.thermaltake.com/tw/csWarranty.aspx#tab-8');
}

function ttRazer() {
    window.open('https://www.razer.com/chroma');
}
function ttRazerWorkshop() {
	window.open('https://www2.razer.com/chroma-workshop/games');
}

function ttRazerGuide() {
	window.open('https://bit.ly/RazerxTTRGBPLUSSyncGuide');
}


function ttAmazonAlexa() {
    window.open('https://developer.amazon.com/alexa-voice-service');
}

function alexaSkillSettingsSOP() {
    window.open('https://bit.ly/TTRGBPlusAlexaSkillSettingsSOP');
}

function iTAKEalexaSkillSettingsSOP() {
    window.open('https://bit.ly/iTAKEAlexaSkillSettingsSOP');
}

function iTAKEAPPAlexaVocieCommand() {
    window.open('https://bit.ly/iTAKEAPPAlexaVocieCommand');
}




function alexaSkillSettingsSOP() {
    window.open('https://bit.ly/TTRGBPlusAlexaSkillSettingsSOP');
}

function PCIE30Extender() {
    window.open('https://www.thermaltake.com/Chassis/Accessories_/_/C_00003013/TT_Premium_PCI_E_3_0_Extender_300mm/design.htm');
}

function makers3d() {
    window.open('https://3dmakers.thermaltake.com/');
}

function SYNCMOTHERBOARD() {
    window.open('https://www.thermaltake.com/pub/media/productattach/db/support/usermanual/5V_RGB_Motherboard_Support_List.pdf');
}

function ramRgbSoftware() {
    window.open('https://www.thermaltake.com/');
}



function iRGBPlusAlexaVoicecommand() {

    if (window.location.hostname == "www.thermaltake.com.cn") {
        window.open('https://www.thermaltake.com/pub/media/wysiwyg/key3/db/support/usermanual/Alexa_voice_command.pdf');
    } else {
        window.open('https://bit.ly/2As6BMD');
    }
}

function ttdpsggplay() {
     window.open('https://play.google.com/store/apps/details?id=com.thermaltake.t829.dpsg');
}

function ttdpsgios() {
    window.open('https://apps.apple.com/tw/app/tt-dps-g/id1028230950?l=zh');
}

function argentM5wlink() {

    if (window.location.hostname == "ru.thermaltake.com") {
        window.open('https://ru.thermaltake.com/argent-m5-wireless-rgb-gaming-mouse.html');
    } else if (window.location.hostname == "tw.thermaltake.com") {
        window.open('https://tw.thermaltake.com/argent-m5-wireless-rgb-gaming-mouse.html');
    } else {
       window.open('https://www.thermaltake.com/argent-m5-wireless-rgb-gaming-mouse.html');
    }
    
    
}

function argentM5link() {

    if (window.location.hostname == "ru.thermaltake.com") {
        window.open('https://ru.thermaltake.com/argent-m5-rgb-gaming-mouse.html');
    } else if (window.location.hostname == "tw.thermaltake.com") {
        window.open('https://tw.thermaltake.com/argent-m5-rgb-gaming-mouse.html');
    } else {
       window.open('https://www.thermaltake.com/argent-m5-rgb-gaming-mouse.html');
    }

}

function argentH5wirelessink() {

    if (window.location.hostname == "ru.thermaltake.com") {
        window.open('https://ru.thermaltake.com/argent-h5-rgb-wireless-gaming-headset.html');
    } else if (window.location.hostname == "tw.thermaltake.com") {
        window.open('https://tw.thermaltake.com/argent-h5-rgb-wireless-gaming-headset.html');
    } else {
       window.open('https://www.thermaltake.com/argent-h5-rgb-wireless-gaming-headset.html');
    }

}

function argentH571link() {
    if (window.location.hostname == "ru.thermaltake.com") {
        window.open('https://ru.thermaltake.com/argent-h5-rgb-7-1-surround-gaming-headset.html');
    } else if (window.location.hostname == "tw.thermaltake.com") {
        window.open('https://tw.thermaltake.com/argent-h5-rgb-7-1-surround-gaming-headset.html');
    } else {
       window.open('https://www.thermaltake.com/argent-h5-rgb-7-1-surround-gaming-headset.html');
    }

}

function argentH5link() {
    if (window.location.hostname == "ru.thermaltake.com") {
        window.open('https://ru.thermaltake.com/argent-h5-stereo-gaming-headset.html');
    } else if (window.location.hostname == "tw.thermaltake.com") {
        window.open('https://tw.thermaltake.com/argent-h5-stereo-gaming-headset.html');
    } else {
       window.open('https://www.thermaltake.com/argent-h5-stereo-gaming-headset.html');
    }

}

function argentHS1link() {

    if (window.location.hostname == "ru.thermaltake.com") {
        window.open('https://ru.thermaltake.com/argent-hs1-rgb-headset-stand.html');
    } else if (window.location.hostname == "tw.thermaltake.com") {
        window.open('https://tw.thermaltake.com/argent-hs1-rgb-headset-stand.html');
    } else {
       window.open('https://www.thermaltake.com/argent-hs1-rgb-headset-stand.html');
    }

}

function argentMP1link() {

    if (window.location.hostname == "ru.thermaltake.com") {
        window.open('https://ru.thermaltake.com/argent-mp1-rgb-gaming-mouse-pad.html');
    } else if (window.location.hostname == "tw.thermaltake.com") {
        window.open('https://tw.thermaltake.com/argent-mp1-rgb-gaming-mouse-pad.html');
    } else {
       window.open('https://www.thermaltake.com/argent-mp1-rgb-gaming-mouse-pad.html');
    }

}

function argentMB1link() {

    if (window.location.hostname == "ru.thermaltake.com") {
        window.open('https://ru.thermaltake.com/argent-mb1-rgb-mouse-bungee.html');
    } else if (window.location.hostname == "tw.thermaltake.com") {
        window.open('https://tw.thermaltake.com/argent-mb1-rgb-mouse-bungee.html');
    } else {
       window.open('https://www.thermaltake.com/argent-mb1-rgb-mouse-bungee.html');
    }

}


function argentK5Slink() {

    if (window.location.hostname == "ru.thermaltake.com") {
        window.open('https://ru.thermaltake.com/argent-k5-rgb-gaming-keyboard-cherry-mx-speed-silver.html');
    } else if (window.location.hostname == "tw.thermaltake.com") {
        window.open('https://tw.thermaltake.com/argent-k5-rgb-gaming-keyboard-cherry-mx-speed-silver.html');
    } else {
       window.open('https://www.thermaltake.com/argent-k5-rgb-gaming-keyboard-cherry-mx-speed-silver.html');
    }

}

function argentK5Blink() {


    if (window.location.hostname == "ru.thermaltake.com") {
        window.open('https://ru.thermaltake.com/argent-k5-rgb-gaming-keyboard-cherry-mx-blue.html');
    } else if (window.location.hostname == "tw.thermaltake.com") {
        window.open('https://tw.thermaltake.com/argent-k5-rgb-gaming-keyboard-cherry-mx-blue.html');
    } else {
       window.open('https://www.thermaltake.com/argent-k5-rgb-gaming-keyboard-cherry-mx-blue.html');
    }

}



function ttdpsgapp() {
    		if (window.location.hostname === "www.thermaltake.com.cn") {

    		    window.open('https://file.thermaltake.com/file/software/TtDPSGApp_Ver331_China.zip');

    		} else {
    		    window.open('https://bit.ly/TtDPSGApp_Ver331_Global');
    		}
}






function SPMAlexaSkillSettings() {



		if (window.location.hostname == "www.thermaltake.com.cn") {

			window.open('https://www.thermaltake.com/pub/media/wysiwyg/key3/db/support/usermanual/SPMAlexaSkillSettings.pdf');

		} else {

			window.open('https://bit.ly/SPMAlexaSkillSettings');

		}

	}



function SPMAlexaVoicecommand() {



	if (window.location.hostname == "www.thermaltake.com.cn") {

		window.open('https://www.thermaltake.com/pub/media/wysiwyg/key3/db/support/usermanual/SPMAlexaVoicecommand.pdf');

	} else {

		window.open('https://bit.ly/SPMAlexaVoicecommand');

	}

}



require(['jquery'],function($ ){

	/* ------  常用 很常變更------- */

	$(function () {
        if (window.location.hostname == "www.thermaltake.com.cn") {
            $(".ttpriingfan").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/ttpriingfan/ttpriingfan.html");
        } else if (window.location.hostname == "innertw.thermaltake.com" || window.location.hostname == "tw.thermaltake.com") {
            $(".ttpriingfan").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/ttpriingfan/ttpriingfan.html");
        } else if ( window.location.hostname == "ru.thermaltake.com") {
            $(".ttpriingfan").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/ttpriingfan/ttpriingfan.html");
        } else if ( window.location.hostname == "pl.thermaltake.com") {
            $(".ttpriingfan").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/ttpriingfan/ttpriingfan_pl.html");
        } else {
            $(".ttpriingfan").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/ttpriingfan/ttpriingfan.html");
        }
        });



	$(function () {


        if (window.location.hostname == "www.thermaltake.com.cn") {
            $(".PatentedTTRGBPLUS").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/PatentedTTRGBPLUS/index.html");
        } else if (window.location.hostname == "innertw.thermaltake.com" || window.location.hostname == "tw.thermaltake.com") {
            $(".PatentedTTRGBPLUS").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/PatentedTTRGBPLUS/index.html");
        } else if ( window.location.hostname == "ru.thermaltake.com") {
            $(".PatentedTTRGBPLUS").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/PatentedTTRGBPLUS/index.html");
        } else if ( window.location.hostname == "pl.thermaltake.com") {
            $(".PatentedTTRGBPLUS").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/PatentedTTRGBPLUS/index_pl.html");
        } else {
            $(".PatentedTTRGBPLUS").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/PatentedTTRGBPLUS/index.html");
        }


        if (window.location.hostname == "www.thermaltake.com.cn") {
            $(".SyncALL").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/SyncALLSayHelloTT/index.html");
        } else if (window.location.hostname == "innertw.thermaltake.com" || window.location.hostname == "tw.thermaltake.com") {
            $(".SyncALL").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/SyncALLSayHelloTT/index.html");
        } else if ( window.location.hostname == "ru.thermaltake.com") {
            $(".SyncALL").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/SyncALLSayHelloTT/index.html");
        } else if ( window.location.hostname == "pl.thermaltake.com") {
            $(".SyncALL").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/SyncALLSayHelloTT/index_pl.html");
        } else {
            $(".SyncALL").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/SyncALLSayHelloTT/index.html");
        }

		// $(".PatentedTTRGBPLUS").load( "https://file.thermaltake.com/pub/media/wysiwyg/key3/html/PatentedTTRGBPLUS/index.html");

        // $(".SyncALL").load(  "https://file.thermaltake.com/pub/media/wysiwyg/key3/html/SyncALLSayHelloTT/index.html");
        
        $(".downbannergl").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/banner/en.html");


        $(".iRGBPlusPsusyncRazerAlexaRWD").load( htmlFolder + "/SyncRazerAlexapsu/iRGBPlusSyncRazerAlexaRWD.html");
	

	/*Cooler Case 版 Template  */


		// if (window.location.hostname == "jp.thermaltake.com") {

		// 		$(".syncRazerAlexa").load("/" + htmlFolder + "/SyncRazerAlexa/SyncRazerAlexajp.html");

		// } else {

		// 		$(".syncRazerAlexa").load("/" + htmlFolder + "/SyncRazerAlexa/SyncRazerAlexa.html");

		// }


		// if (window.location.hostname == "jp.thermaltake.com") {
		//    $(".syncRazerAlexa2").load("/" + htmlFolder + "/SyncRazerAlexa2/SyncRazerAlexajp.html");

		// } else {
		//    $(".syncRazerAlexa2").load("/" + htmlFolder + "/SyncRazerAlexa2/SyncRazerAlexa.html");

		// }


		// $(".ttrgbAlexa").load("/" + htmlFolder + "/ttrgbAlexa/ttrgbAlexa.html");



	/*PSU 版*/

		// if (window.location.hostname == "jp.thermaltake.com") {

		// 	$(".psusyncRazerAlexa").load("/" + htmlFolder + "/SyncRazerAlexapsu/SyncRazerAlexajp.html");

		// } else {

		// 	 $(".psusyncRazerAlexa").load("/" + htmlFolder + "/SyncRazerAlexapsu/SyncRazerAlexa.html");

        // }
        
        //     if (window.location.hostname == "jp.thermaltake.com") {

        //         var folder = "";
        //         var htmlFolder = "https://file.thermaltake.com/pub/media/wysiwyg/key3/html";
        //         if (window.location.hostname == "tw.thermaltake.com" || window.location.hostname == "mgttptw.thermaltake.com") {
        //             folder = "https://file.thermaltake.com/pub/media/wysiwyg/key3/html_tw";
        //             htmlFolder = "html_tw";
        //         }



        //         $(".iRGBPlusPsusyncRazerAlexa").load("/" + htmlFolder + "/SyncRazerAlexapsu/SyncRazerAlexajp.html");
        //     } else {

        //         var folder = "";
        //         var htmlFolder = "html";
        //         if (window.location.hostname == "tw.thermaltake.com" || window.location.hostname == "mgttptw.thermaltake.com") {
        //             folder = "tw/";
        //             htmlFolder = "html_tw";
        //         }

        //         $(".iRGBPlusPsusyncRazerAlexa").load("/" + htmlFolder + "/SyncRazerAlexapsu/iRGBPlusSyncRazerAlexa.html");
        //     }


    /*記憶體 */
    

    //     if (window.location.hostname == "tw.thermaltake.com" || window.location.hostname == "innertw.thermaltake.com" || window.location.hostname == "mgttptw.thermaltake.com") {

    //         $(".neomakerSoftware").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/neomakerSoftware_tw.html");

	// } else if (window.location.hostname == "www.thermaltake.com.cn") {

    //         $(".neomakerSoftware").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/neomakerSoftware_cn.html");

	// }  else if (window.location.hostname == "pl.thermaltake.com") {

    //         $(".neomakerSoftware").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/neomakerSoftware_pl.html");

	// } else {

    //         $(".neomakerSoftware").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/neomakerSoftware_en.html");

    // }
    

        if (window.location.hostname == "tw.thermaltake.com" || window.location.hostname == "innertw.thermaltake.com" || window.location.hostname == "mgttptw.thermaltake.com") {

            $(".neomakerSoftwareMemory").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/neomakerSoftware_memory_tw.html");

	} else if (window.location.hostname == "www.thermaltake.com.cn") {

            $(".neomakerSoftwareMemory").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/neomakerSoftware_memory_cn.html");

	}  else if (window.location.hostname == "ru.thermaltake.com") {

            $(".neomakerSoftwareMemory").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/neomakerSoftware_memory_ru.html");

	} else if (window.location.hostname == "pl.thermaltake.com") {

            $(".neomakerSoftwareMemory").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/neomakerSoftware_memory_pl.html");

	} else {

            $(".neomakerSoftwareMemory").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/neomakerSoftware_memory_en.html");

	}





    //     if (window.location.hostname == "tw.thermaltake.com" || window.location.hostname == "innertw.thermaltake.com" || window.location.hostname == "mgttptw.thermaltake.com") {

    //         $(".key3_software_memory").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/key3_software_memory_tw.html");

	// } else if (window.location.hostname == "www.thermaltake.com.cn") {

    //         $(".key3_software_memory").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/key3_software_memory_cn.html");

	// } else if (window.location.hostname == "ru.thermaltake.com") {

    //         $(".key3_software_memory").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/key3_software_memory_ru.html");

	// }  else if (window.location.hostname == "pl.thermaltake.com") {

    //         $(".key3_software_memory").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/key3_software_memory_pl.html");

	// } else {

    //         $(".key3_software_memory").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/key3_software_memory_en.html");

    // }
    




    
    //     if (window.location.hostname == "tw.thermaltake.com" || window.location.hostname == "innertw.thermaltake.com" || window.location.hostname == "mgttptw.thermaltake.com") {

    //         $(".key3_software_4fan").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/key3_software_4ledfan_tw.html");

	// } else if (window.location.hostname == "www.thermaltake.com.cn") {

    //         $(".key3_software_4fan").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/key3_software_4ledfan_cn.html");

	// } else if (window.location.hostname == "ru.thermaltake.com") {

    //         $(".key3_software_4fan").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/key3_software_4ledfan_ru.html");

	// } else if (window.location.hostname == "pl.thermaltake.com") {

    //         $(".key3_software_4fan").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/key3_software_4ledfan_pl.html");

	// }  else {

    //         $(".key3_software_4fan").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/key3_software_4ledfan_en.html");
    // }
    



        /* 高容量記憶體  黑 */

        if (window.location.hostname == "tw.thermaltake.com" || window.location.hostname == "innertw.thermaltake.com" || window.location.hostname == "mgttptw.thermaltake.com") {

            if (window.location.pathname == "/toughram-rgb-memoryddr4-4000mhz-32g-16g-x2.html") {

                $(".shareMemory_b").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/memory_b_tw.html");

            } else {

                $(".shareMemory_b").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/memory_3236_b_tw.html");
            }

        } else if (window.location.hostname == "www.thermaltake.com.cn") {

            $(".shareMemory_b").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/memory_b_cn.html");

            if (window.location.pathname == "/toughram-rgb-memoryddr4-4000mhz-32g-16g-x2.html") {

            } else {

                $(".shareMemory_b").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/memory_3236_b_cn.html");
            }

        } else {


            if (window.location.pathname == "/toughram-rgb-memoryddr4-4000mhz-32g-16g-x2.html") {

                $(".shareMemory_b").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/memory_b_en.html");

            } else {

                $(".shareMemory_b").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/memory_3236_b_en.html");
            }


        }

        /* SyncMotherboard2*/

        // if (window.location.hostname == "tw.thermaltake.com" || window.location.hostname == "innertw.thermaltake.com" || window.location.hostname == "mgttptw.thermaltake.com") {

        //     $(".SyncMotherboard2").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/SyncMotherboard/SyncMotherboard2.html");

        // } else if (window.location.hostname == "www.thermaltake.com.cn") {

        //     $(".SyncMotherboard2").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/SyncMotherboard/SyncMotherboard2.html");

        // } else if (window.location.hostname == "pl.thermaltake.com") {

        //     $(".SyncMotherboard2").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/SyncMotherboard/SyncMotherboard2_pl.html");

        // } else {

        //     $(".SyncMotherboard2").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/SyncMotherboard/SyncMotherboard2.html");

        // }



        /* tt rgb plus 1.0+2.0*/

        // if (window.location.hostname == "tw.thermaltake.com" || window.location.hostname == "innertw.thermaltake.com" || window.location.hostname == "mgttptw.thermaltake.com") {

        //     $(".ttrgbplus1020").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/ttrgbplus1020_tw.html");

        // } else if (window.location.hostname == "www.thermaltake.com.cn") {

        //     $(".ttrgbplus1020").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/ttrgbplus1020_cn.html");

        // } else if (window.location.hostname == "pl.thermaltake.com") {

        //     $(".ttrgbplus1020").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/ttrgbplus1020_en.html");

        // } else {

        //     $(".ttrgbplus1020").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/ttrgbplus1020_en.html");

        // }



        /* tt rgb plus 2.0*/

        // if (window.location.hostname == "tw.thermaltake.com" || window.location.hostname == "innertw.thermaltake.com" || window.location.hostname == "mgttptw.thermaltake.com") {

        //     $(".ttrgbplus20").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/ttrgbplus20_tw.html");

        // } else if (window.location.hostname == "www.thermaltake.com.cn") {

        //     $(".ttrgbplus20").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/ttrgbplus20_cn.html");

        // } else if (window.location.hostname == "pl.thermaltake.com") {

        //     $(".ttrgbplus20").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/ttrgbplus20_en.html");

        // } else {

        //     $(".ttrgbplus20").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/ttrgbplus20_en.html");

        // }

        /* TTAIVoiceControl*/
        // if (window.location.hostname == "tw.thermaltake.com" || window.location.hostname == "innertw.thermaltake.com" || window.location.hostname == "mgttptw.thermaltake.com") {

        //     $(".TTAIVoiceControl").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/TTAIVoiceControl_tw.html");

        // } else if (window.location.hostname == "www.thermaltake.com.cn") {

        //     $(".TTAIVoiceControl").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/TTAIVoiceControl_cn.html");

        // } else if (window.location.hostname == "pl.thermaltake.com") {

        //     $(".TTAIVoiceControl").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/TTAIVoiceControl_en.html");

        // } else {

        //     $(".TTAIVoiceControl").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/TTAIVoiceControl_en.html");

        // }


        /* NEONMAKER*/
        // if (window.location.hostname == "tw.thermaltake.com" || window.location.hostname == "innertw.thermaltake.com" || window.location.hostname == "mgttptw.thermaltake.com") {

        //     $(".key3NEONMAKER").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/NEONMAKER_tw.html");

        // } else if (window.location.hostname == "www.thermaltake.com.cn") {

        //     $(".key3NEONMAKER").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/NEONMAKER_en.html");

        // } else if (window.location.hostname == "pl.thermaltake.com") {

        //     $(".key3NEONMAKER").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/NEONMAKER_en.html");

        // } else {

        //     $(".key3NEONMAKER").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/NEONMAKE_en.html");

        // }

        /* SyncWithRazer */
        // if (window.location.hostname == "tw.thermaltake.com" || window.location.hostname == "innertw.thermaltake.com" || window.location.hostname == "mgttptw.thermaltake.com") {

        //     $(".SyncWithRazer").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/SyncWithRazer_tw.html");

        // } else if (window.location.hostname == "www.thermaltake.com.cn") {

        //     $(".SyncWithRazer").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/SyncWithRazer_cn.html");

        // } else if (window.location.hostname == "pl.thermaltake.com") {

        //     $(".SyncWithRazer").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/SyncWithRazer_en.html");

        // } else {

        //     $(".SyncWithRazer").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/SyncWithRazer_en.html");

        // }

        /* SyncMotherboardRGB */
        // if (window.location.hostname == "tw.thermaltake.com" || window.location.hostname == "innertw.thermaltake.com" || window.location.hostname == "mgttptw.thermaltake.com") {

        //     $(".SyncMotherboardRGB").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/SyncMotherboardRGB_tw.html");

        // } else if (window.location.hostname == "www.thermaltake.com.cn") {

        //     $(".SyncMotherboardRGB").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/SyncMotherboardRGB_cn.html");

        // } else if (window.location.hostname == "pl.thermaltake.com") {

        //     $(".SyncMotherboardRGB").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/SyncMotherboardRGB_en.html");

        // } else {

        //     $(".SyncMotherboardRGB").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/SyncMotherboardRGB_en.html");

        // }


        /* AmazonAlexa*/
        // if (window.location.hostname == "tw.thermaltake.com" || window.location.hostname == "innertw.thermaltake.com" || window.location.hostname == "mgttptw.thermaltake.com") {

        //     $(".AmazonAlexa").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/AmazonAlexa_tw.html");

        // } else if (window.location.hostname == "www.thermaltake.com.cn") {

        //     $(".AmazonAlexa").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/AmazonAlexa_cn.html");

        // } else if (window.location.hostname == "pl.thermaltake.com") {

        //     $(".AmazonAlexa").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/AmazonAlexa_en.html");

        // } else {

        //     $(".AmazonAlexa").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/AmazonAlexa_en.html");

        // }


        /* Memory XMP Warranty*/
        // if (window.location.hostname == "tw.thermaltake.com" || window.location.hostname == "innertw.thermaltake.com" || window.location.hostname == "mgttptw.thermaltake.com") {

        //     $(".MemoryXMPWarranty").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/MemoryXMPWarranty_tw.html");

        // } else if (window.location.hostname == "www.thermaltake.com.cn") {

        //     $(".MemoryXMPWarranty").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/MemoryXMPWarranty_en.html");

        // } else if (window.location.hostname == "pl.thermaltake.com") {

        //     $(".MemoryXMPWarranty").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/MemoryXMPWarranty_en.html");

        // } else {

        //     $(".MemoryXMPWarranty").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/key3_software/MemoryXMPWarranty_en.html");

        // }




        /* 高容量記憶體  白 */

        if (window.location.hostname == "tw.thermaltake.com" || window.location.hostname == "innertw.thermaltake.com" || window.location.hostname == "mgttptw.thermaltake.com") {

            if (window.location.pathname == "/toughram-rgb-memory-ddr4-4000mhz-32gb-16gb-x-2-white.html") {

                $(".shareMemory_w").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/memory_w_tw.html");

            } else {

                $(".shareMemory_w").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/memory_3236_w_tw.html");
            }

        } else if (window.location.hostname == "www.thermaltake.com.cn") {

            $(".shareMemory_w").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/memory_w_cn.html");

            if (window.location.pathname == "/toughram-rgb-memory-ddr4-4000mhz-32gb-16gb-x-2-white.html") {

            } else {

                $(".shareMemory_w").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/memory_3236_w_cn.html");
            }

        } else {


            if (window.location.pathname == "/toughram-rgb-memory-ddr4-4000mhz-32gb-16gb-x-2-white.html") {

                $(".shareMemory_w").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/memory_w_en.html");

            } else {

                $(".shareMemory_w").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/memory_3236_w_en.html");
            }


        }




       
        /* TOUGHRAM XG RGB Memory_黑 */

        if (window.location.hostname == "tw.thermaltake.com" || window.location.hostname == "innertw.thermaltake.com" || window.location.hostname == "mgttptw.thermaltake.com") {

            if (window.location.pathname == "/toughram-xg-rgb-memory-ddr4-4600mhz-16gb-8gb-x2.html") {

                $(".Memory_XG_B").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Memory_XG_B_4600_TW.html");

            }  else if (window.location.pathname == "/toughram-xg-rgb-memory-ddr4-3600mhz-16gb-8gb-x2.html") {

                $(".Memory_XG_B").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Memory_XG_B_3600_TW.html");

            }else {

                $(".Memory_XG_B").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Memory_XG_B_TW.html");
            }

        } else if (window.location.hostname == "www.thermaltake.com.cn") {

             if (window.location.pathname == "/toughram-xg-rgb-memory-ddr4-4600mhz-16gb-8gb-x2.html") {

                $(".Memory_XG_B").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Memory_XG_B_4600_CN.html");

            }  else if (window.location.pathname == "/toughram-xg-rgb-memory-ddr4-3600mhz-16gb-8gb-x2.html") {

                $(".Memory_XG_B").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Memory_XG_B_3600_CN.html");

            }else {

                $(".Memory_XG_B").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Memory_XG_B_CN.html");
            }
            

        } else if (window.location.hostname == "ru.thermaltake.com") {

            if (window.location.pathname == "/toughram-xg-rgb-memory-ddr4-4600mhz-16gb-8gb-x2.html") {

               $(".Memory_XG_B").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Memory_XG_B_4600_RU.html");

           }  else if (window.location.pathname == "/toughram-xg-rgb-memory-ddr4-3600mhz-16gb-8gb-x2.html") {

               $(".Memory_XG_B").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Memory_XG_B_3600_RU.html");

           }else {

               $(".Memory_XG_B").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Memory_XG_B_RU.html");
           }
           

       } else if (window.location.hostname == "pl.thermaltake.com") {

        if (window.location.pathname == "/toughram-xg-rgb-memory-ddr4-4600mhz-16gb-8gb-x2.html") {

           $(".Memory_XG_B").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Memory_XG_B_4600_PL.html");

       }  else if (window.location.pathname == "/toughram-xg-rgb-memory-ddr4-3600mhz-16gb-8gb-x2.html") {

           $(".Memory_XG_B").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Memory_XG_B_3600_PL.html");

       }else {

           $(".Memory_XG_B").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Memory_XG_B_PL.html");
       }
       

   }else if (window.location.hostname == "de.thermaltake.com") {

        if (window.location.pathname == "/toughram-xg-rgb-memory-ddr4-4600mhz-16gb-8gb-x2.html") {

           $(".Memory_XG_B").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Memory_XG_B_4600_de.html");

       }  else if (window.location.pathname == "/toughram-xg-rgb-memory-ddr4-3600mhz-16gb-8gb-x2.html") {

           $(".Memory_XG_B").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Memory_XG_B_3600_de.html");

       }else {

           $(".Memory_XG_B").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Memory_XG_B_de.html");
       }
       

   } else {


            if (window.location.pathname == "/toughram-xg-rgb-memory-ddr4-4600mhz-16gb-8gb-x2.html") {

                $(".Memory_XG_B").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Memory_XG_B_4600.html");

            }  else if (window.location.pathname == "/toughram-xg-rgb-memory-ddr4-3600mhz-16gb-8gb-x2.html") {

                $(".Memory_XG_B").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Memory_XG_B_3600.html");

            }else {

                $(".Memory_XG_B").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Memory_XG_B.html");
            }


        }
        /* TOUGHRAM XG RGB Memory_白 */

        if (window.location.hostname == "tw.thermaltake.com" || window.location.hostname == "innertw.thermaltake.com" || window.location.hostname == "mgttptw.thermaltake.com") {

            $(".Memory_XG_W").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Memory_XG_W_TW.html");

        } else if (window.location.hostname == "www.thermaltake.com.cn") {

            $(".Memory_XG_W").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Memory_XG_W_CN.html");

         } else if (window.location.hostname == "de.thermaltake.com") {

            $(".Memory_XG_W").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Memory_XG_W_DE.html");

        } else if (window.location.hostname == "ru.thermaltake.com") {

            $(".Memory_XG_W").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Memory_XG_W_RU.html");

        } else if (window.location.hostname == "pl.thermaltake.com") {

            $(".Memory_XG_W").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Memory_XG_W_PL.html");

        } else {

            $(".Memory_XG_W").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Memory_XG_W_EN.html");

        }

        /* Toughram 松石綠.勁速綠 AR區塊*/

        if (window.location.hostname == "tw.thermaltake.com" || window.location.hostname == "innertw.thermaltake.com" || window.location.hostname == "mgttptw.thermaltake.com") {

            if (window.location.pathname == "/toughram-rgb-memory-ddr4-3600mhz-16gb-8gb-x2-racing-green.html" || "/test2.html") {

                if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                    $(".toughram_ar" || ".MemoryAR" ).load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Toughram_ar/Toughram_ar_RG_ios_TW.html");
                    } else if (/(Android)/i.test(navigator.userAgent)) {
                        $(".toughram_ar" || ".MemoryAR").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Toughram_ar/Toughram_ar_RG_android_TW.html");
                    } else {
                        $(".toughram_ar" || ".MemoryAR").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Toughram_ar/Toughram_ar_RG_PC_TW.html");
                    };

            }else {

                if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                    $(".toughram_ar" || ".MemoryAR").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Toughram_ar/Toughram_ar_ios_TW.html");
                    } else if (/(Android)/i.test(navigator.userAgent)) {
                        $(".toughram_ar" || ".MemoryAR").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Toughram_ar/Toughram_ar_android_TW.html");
                    } else {
                        $(".toughram_ar" || ".MemoryAR").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Toughram_ar/Toughram_ar_PC_TW.html");
                    };
            }
 


        } else if (window.location.hostname == "www.thermaltake.com.cn") {

            if (window.location.pathname == "/toughram-rgb-memory-ddr4-3600mhz-16gb-8gb-x2-racing-green.html") {

                if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                    $(".toughram_ar" || ".MemoryAR").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Toughram_ar/Toughram_ar_RG_ios_CN.html");
                    } else if (/(Android)/i.test(navigator.userAgent)) {
                        $(".toughram_ar" || ".MemoryAR").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Toughram_ar/Toughram_ar_RG_android_CN.html");
                    } else {
                        $(".toughram_ar" || ".MemoryAR").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Toughram_ar/Toughram_ar_RG_PC_CN.html");
                    };

            }else {

                if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                    $(".toughram_ar" || ".MemoryAR").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Toughram_ar/Toughram_ar_ios_CN.html");
                    } else if (/(Android)/i.test(navigator.userAgent)) {
                        $(".toughram_ar" || ".MemoryAR").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Toughram_ar/Toughram_ar_android_CN.html");
                    } else {
                        $(".toughram_ar" || ".MemoryAR").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Toughram_ar/Toughram_ar_PC_CN.html");
                    };
            }

        } else {

            if (window.location.pathname == "/toughram-rgb-memory-ddr4-3600mhz-16gb-8gb-x2-racing-green.html") {

                if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                    $(".toughram_ar" || ".MemoryAR").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Toughram_ar/Toughram_ar_RG_ios.html");
                    } else if (/(Android)/i.test(navigator.userAgent)) {
                        $(".toughram_ar" || ".MemoryAR").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Toughram_ar/Toughram_ar_RG_android.html");
                    } else {
                        $(".toughram_ar" || ".MemoryAR").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Toughram_ar/Toughram_ar_RG_PC.html");
                    };

            }else {

                if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                    $(".toughram_ar" || ".MemoryAR").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Toughram_ar/Toughram_ar_ios.html");
                    } else if (/(Android)/i.test(navigator.userAgent)) {
                        $(".toughram_ar" || ".MemoryAR").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Toughram_ar/Toughram_ar_android.html");
                    } else {
                        $(".toughram_ar" || ".MemoryAR").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/memory/Toughram_ar/Toughram_ar_PC.html");
                    };
            }

        };
        /* Toughram 黑.白.紅 AR區塊 以後加新的從這邊加*/

        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
            $(".TOUGHRAM_RGB_ar").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/Product_AR/TOUGHRAM_RGB/TOUGHRAM_RGB_ar_ios.html");
            } else if (/(Android)/i.test(navigator.userAgent)) {
                $(".TOUGHRAM_RGB_ar").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/Product_AR/TOUGHRAM_RGB/TOUGHRAM_RGB_ar_android.html");
            } else {
                $(".TOUGHRAM_RGB_ar").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/Product_AR/TOUGHRAM_RGB/TOUGHRAM_RGB_ar_pc.html");
            };

       /* E700電競椅 AR區塊*/
       if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        $(".E700_ar").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/Product_AR/E700/E700_ar_ios.html");
        } else if (/(Android)/i.test(navigator.userAgent)) {
            $(".E700_ar").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/Product_AR/E700/E700_ar_android.html");
        } else {
            $(".E700_ar").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/Product_AR/E700/E700_ar_pc.html");
        };
   
       /* TOWER 100 AR區塊*/

       if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        $(".TOWER100_ar").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/Product_AR/TOWER100/Tower100_ar_ios.html");
        } else if (/(Android)/i.test(navigator.userAgent)) {
            $(".TOWER100_ar").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/Product_AR/TOWER100/Tower100_ar_android.html");
        } else {
            $(".TOWER100_ar").load("https://file.thermaltake.com/pub/media/wysiwyg/key3/html/Product_AR/TOWER100/Tower100_ar_pc.html");
        };




    });
    

});

// 更改Compatible 
//ContacSilent12 - CL-P039-AL12BL-A

var Compatible_ContacSilent12a = document.querySelector(".Compatible_ContacSilent12a");
var Compatible_ContacSilent12b = document.querySelector(".Compatible_ContacSilent12b");

if (Compatible_ContacSilent12a !== null) {
    Compatible_ContacSilent12a.innerHTML = "AMD AM5/AM4/FM2/FM1/AM3+/AM3/AM2+/AM2";
  } 

if (Compatible_ContacSilent12b !== null) {
    Compatible_ContacSilent12b.innerHTML = "Intel LGA 1700/1200/1156/1155/1151/1150";
  } 
 

//TOUGHAIR 510 , ux200, TOUGHAIR 110, TOUGHAIR 510,
//TOUGHAIR 510 Turquoise, TOUGHAIR 510 Racing Green

var Compatible_a1 = document.querySelector(".Compatible_a1");
if (Compatible_a1 !== null) {
    Compatible_a1.innerHTML = "Intel:<br> LGA 1700/1200/1156/1155/1151/1150<br>AMD:<br> AM5/AM4/AM3+/AM3/AM2+/AM2/FM2/FM1";
  }
//contac-9-se-cpu-cooler, contac-silent-12

var Compatible_b1 = document.querySelector(".Compatible_b1");
if (Compatible_b1 !== null) {
    Compatible_b1.innerHTML = "Intel:<br> LGA 1700/1200/1156/1155/1151/1150<br>AMD:<br> AM5/AM4/FM2/FM1/AM3+/AM3/AM2+/AM2";
  }

// TOUGHLIQUID 280/240/360/420 EX Pro ARGB  
var Compatible_c1 = document.querySelector(".Compatible_c1");
if (Compatible_c1 !== null) {
    Compatible_c1.innerHTML = "Intel: LGA 2066/2011/1700/1200/1156/1155/1151/1150<br>AMD: AM5/AM4/AM3+/AM3/AM2+/AM2";
  }

  //TT PlayLink App 20241104 Chloe

function TTPlayLinkAppleStore() {
	window.open('https://apps.apple.com/tw/app/tt-playlink/id6612012486?fbclid=IwZXh0bgNhZW0CMTAAAR2oUo05BAjtJ6P3LP8nOKIm6QDg0D7JSpUmXimLvkpeXAgqsYXNGOxLviY_aem_8n_5jv2a-BdWc36V2NrEKw');
}
function TTPlayLinkGooglePlay() {
	window.open('https://play.google.com/store/apps/details?id=com.thermaltake.ttplaylink&pcampaignid=web_share&fbclid=IwY2xjawGIM91leHRuA2FlbQIxMAABHddy-6Yv0a5TKDdQ8dPvzYEAcEDDkwQCKAsGMpiKXc6jGF-_A8lXk_cgaQ_aem_Lm4Z4WEMyZvGFlHu21P5VQ');
}
